import { render, staticRenderFns } from "./ProcessingRegistration.vue?vue&type=template&id=4d1f85b6"
import script from "./ProcessingRegistration.vue?vue&type=script&lang=js"
export * from "./ProcessingRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports